'use strict';

function anchorFunction(g) {
  function anchorScrollTo() {
    var $elt = $("[data-target]");

    $($elt).each(function(e) {
      var $anchorBtn = $(this);

      $anchorBtn.on("click", function() {
        var $anchor = "#" + $anchorBtn.data("target");
        var $anchorTop = $($anchor).offset().top;

        if($anchorBtn.data("target") == "top-window") {
          anchorTop = 0;
        }

        $("html, body").animate( { scrollTop: $anchorTop }, 750);
      });
    });
  };

  function init() {
    anchorScrollTo();
  }

  init();
}
